import cleanedFilename from '~/util/cleanedFilename';

export default {
  CONTAINER: `${cleanedFilename(__filename)}-container`,
  CARD_HEADER: `${cleanedFilename(__filename)}-card-header`,
  DONUT_CHART: `${cleanedFilename(__filename)}-donut-chart`,
  NO_REVENUE: `${cleanedFilename(__filename)}-no-revenue`,
};
